var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-max-width site-breadcrumbs"},[_c('div',{},[_c('ul',{staticClass:"breadcrumbs"},_vm._l((_vm.crumbs),function(crumb,index){return _c('li',{key:index},[_c('a',{attrs:{"href":crumb.url}},[_vm._v(_vm._s(crumb.title))]),_vm._v(" "),_c('span',[_vm._v(">")])])}),0)])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d7c37eb","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/Breadcrumbs.vue
// module id = 2wjI
// module chunks = 1